module.exports = __webpack_public_path__ + "static/media/Graphic7.595358c0.png";